const BRAND = `${process.env.REACT_APP_BACKEND_URL}/api/uploads`;

export function LogoMark({ size = 34, className = "" }) {
  return (
    <img
      src={`${BRAND}/logo_symbol.png`}
      alt=""
      aria-hidden="true"
      className={`object-contain ${className}`}
      style={{ height: size, width: "auto" }}
    />
  );
}

export default function Logo() {
  return (
    <img
      src={`${BRAND}/logo_horizontal.png`}
      alt="Dirty Church Chronicles"
      data-testid="brand-logo"
      className="h-12 sm:h-14 w-auto object-contain"
    />
  );
}
